export default "__VITE_ASSET__BnHhtMcW__"